import { PROJECTEN } from "./omgevingsGrendel";
import { draaiendeRelease } from "./draaiendeRelease";
import {
  GEDEELDE_SENTRY_OPTIES,
  scrubSentryEvent,
} from "@collectr/observability";
import * as Sentry from "@sentry/react";

/**
 * Operator App — foutrapportage.
 *
 * De maskering zelf staat NIET hier maar in `@collectr/observability`, samen met
 * die van de drie portalen. Aanleiding: op 09-08-2026 bleek dat de versterking
 * van 08-08 alleen dit bestand had geraakt en de drie portaalkopieën op de oude
 * versie stonden — met een live lek van debiteur-toegangstokens tot gevolg.
 * Eén import kan afdwingen wat een pariteitstest alleen kan bewaken.
 *
 * Zonder VITE_SENTRY_DSN is dit een stille no-op.
 */

// Defensief lezen, net als in `supabase.ts`: buiten Vite (node, tests) bestaat
// `import.meta.env` niet, en een harde toegang laat elke module die dit bestand
// aanraakt al bij het importeren stukgaan.
const metaEnv = (
  import.meta as ImportMeta & { env?: Record<string, string | undefined> }
).env;
const rawDsn = metaEnv?.VITE_SENTRY_DSN;
const dsn = typeof rawDsn === "string" ? rawDsn.trim() : "";

export function initSentry(): void {
  if (!dsn) return;

  Sentry.init({
    dsn,
    environment: (() => {
      try {
        return (
          PROJECTEN[
            new URL(metaEnv?.VITE_SUPABASE_URL ?? "").hostname.split(".")[0]
          ] ?? "unknown"
        );
      } catch {
        return "unknown";
      }
    })(),
    release: draaiendeRelease()?.versie,
    dist: draaiendeRelease()?.buildId ?? undefined,
    ...GEDEELDE_SENTRY_OPTIES,
    beforeSend(event) {
      return scrubSentryEvent(event);
    },
  });
}

export { Sentry };
